import { Container, ContentContainer, Row, LogoContainer, InfoContainer } from './styles';

import Section from '../Section';

import Reveal from '../../components/Reveal';

import instagram from '../../assets/images/instagram.svg';
import facebook from '../../assets/images/facebook.svg';
import linkedin from '../../assets/images/linkedin.svg';
import twitter from '../../assets/images/twitter.svg';

export default function Footer() {
  return (
    <Container>
      <Section>
        <ContentContainer>
          <Row>
            <LogoContainer>
              <Reveal>
                <h3>Maid Aid 4 You</h3>
              </Reveal>
              <Reveal delay="0.3">
                <p>General domestic services for your peace of mind</p>
              </Reveal>
              
            </LogoContainer>

            <InfoContainer>
              <Reveal delay="0.4">
                <div>
                  <h3>Topics</h3>
                  <ul>
                    <li><a href='/'>Home</a></li>
                    <li><a href='/services'>Services</a></li>
                    <li><a href='/aboutus'>About us</a></li>
                    {/* <li><a href='/costumers'>Costumers</a></li> */}
                    <li><a href='/contact'>Contact</a></li>
                  </ul>
                  {/* <ul>
                    <li><a href='#home'>Home</a></li>
                    <li><a href='#services'>Services</a></li>
                    <li><a href='#aboutUs'>About us</a></li>
                    <li><a href='#costumers'>Costumers</a></li>
                    <li><a href='#contact'>Contact</a></li>
                  </ul> */}
                </div>
              </Reveal>

              <Reveal delay="0.5">
                <div>
                  <h3>Contact</h3>
                  <ul>
                    {/* <li>Address here</li> */}
                    <li><a href='mailto:contato@maidaid4you.com'>contact@maidaid4you.com</a></li>
                    <li>(857) 230-9073</li>
                    <li>
                      <ul>
                        <li>
                          <a href='https://www.instagram.com/maidaid4you' target="_blank" rel="noopener noreferrer">
                            {/* <img src={instagram} /> */}
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.6999 -0.00366211C12.8253 -0.00180211 13.3955 0.00415791 13.8883 0.0188279L14.0824 0.0251679C14.3066 0.0331379 14.5278 0.0431378 14.7945 0.0556378C15.8586 0.104808 16.5845 0.273138 17.222 0.520638C17.8811 0.774808 18.4378 1.11814 18.9936 1.67398C19.5486 2.22981 19.892 2.78814 20.147 3.44564C20.3936 4.08231 20.562 4.80898 20.612 5.87314C20.6239 6.13981 20.6335 6.36101 20.6414 6.58525L20.6477 6.77934C20.6623 7.27208 20.669 7.84247 20.6711 8.96791L20.6719 9.71351C20.672 9.80461 20.672 9.89861 20.672 9.99561L20.6719 10.2777L20.6713 11.0234C20.6694 12.1488 20.6635 12.7192 20.6488 13.2119L20.6424 13.406C20.6345 13.6303 20.6245 13.8515 20.612 14.1181C20.5628 15.1823 20.3936 15.9081 20.147 16.5456C19.8928 17.2048 19.5486 17.7615 18.9936 18.3173C18.4378 18.8723 17.8786 19.2156 17.222 19.4706C16.5845 19.7173 15.8586 19.8856 14.7945 19.9356C14.5278 19.9475 14.3066 19.9572 14.0824 19.965L13.8883 19.9713C13.3955 19.986 12.8253 19.9926 11.6999 19.9948L10.9541 19.9956C10.863 19.9956 10.7691 19.9956 10.6721 19.9956H10.3899L9.64425 19.9949C8.51885 19.9931 7.94847 19.9871 7.45572 19.9724L7.26164 19.9661C7.03739 19.9581 6.81619 19.9481 6.54953 19.9356C5.48536 19.8865 4.76036 19.7173 4.12203 19.4706C3.46369 19.2165 2.90619 18.8723 2.35036 18.3173C1.79453 17.7615 1.45203 17.2023 1.19703 16.5456C0.94953 15.9081 0.78203 15.1823 0.73203 14.1181C0.72015 13.8515 0.71046 13.6303 0.70261 13.406L0.69632 13.2119C0.68169 12.7192 0.67502 12.1488 0.67286 11.0234L0.672729 8.96791C0.674589 7.84247 0.68054 7.27208 0.69521 6.77934L0.70156 6.58525C0.70953 6.36101 0.71953 6.13981 0.73203 5.87314C0.78119 4.80814 0.94953 4.08314 1.19703 3.44564C1.45119 2.78731 1.79453 2.22981 2.35036 1.67398C2.90619 1.11814 3.46453 0.775638 4.12203 0.520638C4.75953 0.273138 5.48453 0.105638 6.54953 0.0556378C6.81619 0.0437678 7.03739 0.034078 7.26164 0.026228L7.45572 0.0199378C7.94847 0.00529775 8.51885 -0.00137217 9.64425 -0.00353217L11.6999 -0.00366211ZM10.6721 4.99564C7.90913 4.99564 5.67203 7.23517 5.67203 9.99561C5.67203 12.7585 7.91156 14.9956 10.6721 14.9956C13.435 14.9956 15.672 12.7561 15.672 9.99561C15.672 7.23274 13.4325 4.99564 10.6721 4.99564ZM10.6721 6.99564C12.329 6.99564 13.6721 8.33831 13.6721 9.99561C13.6721 11.6525 12.3294 12.9956 10.6721 12.9956C9.01515 12.9956 7.67203 11.653 7.67203 9.99561C7.67203 8.33871 9.01465 6.99564 10.6721 6.99564ZM15.922 3.49564C15.2327 3.49564 14.672 4.05555 14.672 4.74479C14.672 5.43404 15.2319 5.99481 15.922 5.99481C16.6112 5.99481 17.172 5.43491 17.172 4.74479C17.172 4.05555 16.6103 3.49478 15.922 3.49564Z" fill="#F8D3C9"/>
                            </svg>
                          </a>
                        </li>
                        <li>
                          <a href='https://www.facebook.com/profile.php?id=61553636491236&mibextid=ZbWKwL' target="_blank" rel="noopener noreferrer">
                            {/* <img src={facebook} /> */}
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9.9977 0.117188C4.47483 0.117188 -0.00231934 4.59434 -0.00231934 10.1172C-0.00231934 15.1085 3.65453 19.2455 8.4352 19.9957V13.0078H5.89611V10.1172H8.4352V7.91407C8.4352 5.40782 9.9281 4.02344 12.2123 4.02344C13.3064 4.02344 14.4508 4.21875 14.4508 4.21875V6.67969H13.1898C11.9476 6.67969 11.5602 7.45053 11.5602 8.24139V10.1172H14.3336L13.8903 13.0078H11.5602V19.9957C16.3408 19.2455 19.9977 15.1085 19.9977 10.1172C19.9977 4.59434 15.5205 0.117188 9.9977 0.117188Z" fill="#F8D3C9"/>
                            </svg>
                          </a>
                        </li>
                        <li>
                          <a href='https://www.google.com/maps/place/Maid+Aid+4+You/@33.0306956,-80.0659939,17z/data=!3m1!4b1!4m6!3m5!1s0x88fe673f27983d75:0x89dfb65be59420f4!8m2!3d33.0306956!4d-80.0659939!16s%2Fg%2F11qsyx1ktp?entry=ttu' target="_blank" rel="noopener noreferrer">
                            {/* <img src={googleMaps} /> */}
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.6218 9.94531C17.4068 8.16041 18.0263 5.65119 17.4802 3.36357L19.9751 2.29431C20.229 2.18553 20.5229 2.3031 20.6317 2.55692C20.6583 2.61916 20.6721 2.68617 20.6721 2.75388V16.9956L13.6721 19.9956L7.67212 16.9956L1.36908 19.6969C1.11526 19.8057 0.821329 19.6881 0.712549 19.4343C0.685869 19.3721 0.672119 19.305 0.672119 19.2373V4.99561L3.80104 3.65465C3.37235 5.86193 4.01279 8.23581 5.72237 9.94531L10.6721 14.8951L15.6218 9.94531ZM14.2076 8.53111L10.6721 12.0667L7.13659 8.53111C5.18396 6.57852 5.18396 3.4127 7.13659 1.46008C9.08922 -0.492552 12.255 -0.492552 14.2076 1.46008C16.1603 3.4127 16.1603 6.57852 14.2076 8.53111Z" fill="#F8D3C9"/>
                            </svg>

                          </a>
                        </li>
                        {/* twitter */}
                        {/* <li>
                          <a href='#' target="_blank" rel="noopener noreferrer">
                            <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.64978 -0.00439453H0.64978L8.91064 11.0101L1.09973 19.9955H3.74976L10.1381 12.6466L15.6498 19.9956H22.6498L14.0415 8.51791L21.4499 -0.00439453H18.7999L12.8141 6.88139L7.64978 -0.00439453ZM16.6498 17.9956L4.64978 1.99561H6.64978L18.6498 17.9956H16.6498Z" fill="#F8D3C9"/>
                            </svg>
                          </a>
                        </li> */}
                      </ul>
                    </li>
                  </ul>
                </div>
              </Reveal>
            
            </InfoContainer>
          </Row>

          <Row>
            <div>
              <Reveal delay="0.55">
                <span>© 2023 Maid Aid 4 You</span>
              </Reveal>
            </div>
          </Row>
        </ContentContainer>
      </Section>
    </Container>
  );
}
